"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBucketName = getBucketName;
const constants_1 = require("./constants");
function getBucketName(taskName, isDev, assetType, language, useRoarHfBucket) {
    // Applies to ROAR hearts-and-flowers only
    if (useRoarHfBucket) {
        return `roar-levante-tasks/${assetType}/${assetType === 'audio' ? language : taskName}`;
    }
    // Hostile-attribution only exists in dev environment
    const bucket = isDev || taskName === 'hostile-attribution'
        ? constants_1.TASK_BUCKET_NAMES_DEV[assetType]
        : constants_1.TASK_BUCKET_NAMES_PROD[assetType];
    return `${bucket}/${assetType === 'audio' ? language : taskName}`;
}
